import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Button, Radio, RadioChangeEvent, Space } from 'antd';
import React, { useState } from 'react';
import { ApplyAction, ApplyChanges, ConfirmChangesData } from '../../../../../../model/RolesModel';
import { Modal } from '../../../../../common';
import styles from './confirmChanges.module.scss';

const { Group: RadioGroup } = Radio;

type Props = {
	data: ConfirmChangesData;
	handleOnHideModal: () => void;
	handleOnApplyChanges: (isCheck: boolean, applyChanges: ApplyChanges) => void;
};

const ConfirmChanges: React.FC<Props> = ({ data, handleOnHideModal, handleOnApplyChanges }) => {
	//#region state management variables
	const [applyChanges, setApplyChanges] = useState<ApplyChanges>(data.isFolder ? ApplyChanges.ToThisItemAndChildren : ApplyChanges.ToThisItem);
	//#endregion

	const handleOnConfirm = () => {
		handleOnApplyChanges(data.applyAction === ApplyAction.Grant, applyChanges);
	};

	const handleOnChangeApplyChange = (e: RadioChangeEvent) => {
		setApplyChanges(e.target.value);
	};

	const { applyAction, isFolder } = data;

	return (
		<Modal
			onCancel={handleOnHideModal}
			onClickOk={() => null}
			title={_('ConfirmChanges')}
			visible={true}
			customZoomClass={styles.customZoomClass}
			footer={[
				<Button id='applyChangesButton' key='ok' type='primary' onClick={handleOnConfirm} className={styles.footerButton}>
					{_('Ok')}
				</Button>,
				<Button id='cancelChangesButton' key='cancel' onClick={handleOnHideModal} className={styles.footerButton}>
					{_('Cancel')}
				</Button>,
			]}>
			<div className={styles.container}>
				<span>{`${_('YouHaveChosenToMakeChanges')}:`}</span>
				<div className={styles.spacing}>
					<span className={styles.content}>
						{applyAction === ApplyAction.Revoke ? (
							<span>
								<CloseCircleOutlined className={styles.red} /> {_('Revoke')}
							</span>
						) : (
							<span>
								<CheckCircleOutlined className={styles.green} /> {_('Grant')}
							</span>
						)}{' '}
						{_('Permission')}
					</span>
				</div>
				<span>{`${_(!isFolder ? 'DoYouWantToApplyThisChange' : 'DoYouWantToApplyThisChangeFolder')}?`}</span>
				{!isFolder && (
					<div className={styles.spacing}>
						<div className={styles.content}>
							<RadioGroup onChange={handleOnChangeApplyChange} value={applyChanges}>
								<Space direction={'vertical'}>
									<Radio id={`radioOption-${ApplyChanges.ToThisItem}`} value={ApplyChanges.ToThisItem}>
										{_('ToThisItem')}
									</Radio>
									<Radio id={`radioOption-${ApplyChanges.ToThisItemAndChildren}`} value={ApplyChanges.ToThisItemAndChildren}>
										{_('ToThisItemAndChildren')}
									</Radio>
									<Radio id={`radioOption-${ApplyChanges.ToThisItemAndVisibleChildren}`} value={ApplyChanges.ToThisItemAndVisibleChildren}>
										{_('ToThisItemAndVisibleChildren1')} <strong>{_('ToThisItemAndVisibleChildren2')}</strong>
									</Radio>
								</Space>
							</RadioGroup>
						</div>
					</div>
				)}
			</div>
		</Modal>
	);
};

export { ConfirmChanges };
